module.exports = __webpack_public_path__ + "static/media/download-icon-borderless.2f7fae08.svg";